import React from 'react'
import Select from 'react-select';

const categorias = ['A', 'AB', 'AC', 'AD', 'AE', 'B', 'C', 'D', 'E']
const Estados =  ({event}) =>
    // eslint-disable-next-line no-undef
    (_.size(categorias) > 0 ?
    <div>
        <Select
            {...event.input}
            noOptionsMessage={() => ('Nenhuma opção encontrada')}
            placeholder='Selecione a categoria'
            options={categorias.map(elemento => ({
                label: elemento,
                value: elemento
            }))}
            onBlur={() => event.input.onBlur()}
        />
        {event.meta.touched
        && (event.meta.error && <span style={{ color: 'red' }}>{event.meta.error}</span>)}
    </div>
 : ''
)

export default Estados
